<template>
  <div id="header-tab">
    <div
      class="header-area px-10"
    >
      <div
        class="d-flex justify-space-between"
        style="width: 100%"
      >
        <div class="mb-10">
          <h1 class="mb-6">
            Property Snapshot
          </h1>
          <template v-if="resolved">
            <h4
              v-if="propertiesWithActiveEvents > 0"
              class="d-flex align-center"
            >
              <v-icon
                size="23"
                color="error"
                class="mr-2"
              >
                $faExclamationTriangle
              </v-icon>
              {{ propertiesWithActiveEvents }} of {{ totalProperties }} Properties have Active Events
            </h4>
            <h4
              v-else
              class="d-flex align-center"
            >
              <v-icon
                small
                color="success"
                class="mr-2"
              >
                $faCheckCircle
              </v-icon>
              Nice! There are no active events at your properties
            </h4>
          </template>
          <template v-else>
            <v-skeleton-loader type="sentences" />
          </template>
        </div>
        <div
          v-if="hasRecentEvents"
          class="d-flex align-center mt-16 pt-2"
          style="height:47px;"
        >
          <div
            class="px-5 d-flex flex-column"
          >
            <span class="event-label">Noise Events</span>
            <div class="d-flex align-center">
              <v-icon
                small
                class="mr-3 ml-1"
              >
                $faSignalStream
              </v-icon>
              <span class="event-total">{{ totalNoiseEvts }}</span>
            </div>
          </div>
          <v-divider
            class="event-divider"
            vertical
          />
          <div
            class="px-5 d-flex flex-column"
          >
            <span class="event-label">Tamper Events</span>
            <div class="d-flex align-center">
              <v-icon
                small
                class="mr-3 ml-1"
              >
                $faHandPaper
              </v-icon>
              <span class="event-total">{{ totalTamperEvts }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="header-tab d-flex justify-center"
    >
      <img
        style="z-index:50; margin-top:-2px"
        src="../../assets/RefreshTab2.svg"
        alt="Last Refresh"
      >
      <div
        class="pt-2"
        style="position:absolute; z-index:100"
      >
        <div class="tab-text d-flex align-center">
          <v-icon
            :class="resolved ? '' : 'rotate'"
            size="14px"
            class="mr-4"
            :disabled="!resolved"
            @click="handleRefresh"
          >
            $faSyncAlt
          </v-icon>
          <span>LAST REFRESHED ON {{ refreshDate }} AT <span class="font-weight-bold">{{ refreshTime }}</span></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { DateTime } from 'luxon'

  const dateString = 'd LLL yyyy'
  const timeString = 'h:mm a (ZZZZ)'

  export default {
    name: 'LandingHeader',
    props: {
      propertiesWithActiveEvents: {
        type: Number,
        default: 0,
      },
      totalProperties: {
        type: Number,
        default: 0,
      },
      totalNoiseEvts: {
        type: Number,
        default: 0,
      },
      totalTamperEvts: {
        type: Number,
        default: 0,
      },
      hasRecentEvents: {
        type: Boolean,
        default: false,
      },
      resolved: {
        type: Boolean,
        default: false,
      },
      refreshDateTime: DateTime,
    },
    computed: {
      refreshDate () {
        return this.refreshDateTime.toFormat(dateString).toUpperCase()
      },
      refreshTime () {
        return this.refreshDateTime.toFormat(timeString)
      },
    },
    methods: {
      handleRefresh () {
        this.$emit('refresh-list')
      },
    },
  }
</script>
<style lang="scss">
#header-tab {
  position: sticky;
  z-index: 5;
  top:75px;
  .header-area {
    background-color:$na-off-white;
    box-shadow: 0 5px 7px rgba(0, 0, 0, 0.15808);
  }
  .event-divider {
    color:#979797;
    border-bottom-color:#979797;
    border-top-color: #979797;
    border-left-color: #979797;
    border-right-color: #979797
  }
  .event-label {
    font-size: 16px;
    letter-spacing: .2px;
  }
  .event-total {
    font-size: 25px;
    letter-spacing: 0.3px;
  }
  .tab-text {
    font-size: 13px;
    letter-spacing: 1px;
  }
}
.rotate {
  animation: rotate 1s linear infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
